export const attributeDisplayNames = ['WOOP', 'ID', 'URL'];

export const analyticsVersion = '1';
